'use client'

import React, { createContext, useEffect, useState, type PropsWithChildren, useMemo } from 'react'

import { checkPushAsk } from '@/libs/Pushes/pushes.lib'
import { isBrowser } from '@/utils/app/detect'

export const PushContext = createContext<PushContextType | object>({})

export interface PushContextType {
  isOpen: boolean
  updateIsOpen: (value: boolean) => void
  permission: boolean
  updatePermission: (value: boolean) => void
}

type PushProviderProps = PropsWithChildren & {
  webview?: boolean
}

export const PushProvider = ({ children, webview }: PushProviderProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [permission, setPermission] = useState<boolean>(false)

  const updateIsOpen = (value: boolean) => {
    setIsOpen(value)
  }

  const updatePermission = (value: boolean) => {
    setPermission(value)
  }

  const props = useMemo(() => ({ isOpen, updateIsOpen, permission, updatePermission }), [isOpen, permission])

  useEffect(() => {
    if (webview) {
      return
    }
    if (isBrowser() && 'Notification' in globalThis.window) {
      globalThis.window.addEventListener('click', () => {
        checkPushAsk(updateIsOpen, updatePermission)
        setPermission(true)
      })

      if (
        localStorage.getItem('dontAskAgain') === 'true' ||
        permission ||
        globalThis.window?.Notification?.permission === 'granted'
      ) {
        localStorage.removeItem('clickCount')
        localStorage.removeItem('askDenied')
        localStorage.removeItem('lastDeniedDate')
        globalThis.window.removeEventListener('click', () => {
          checkPushAsk(updateIsOpen, updatePermission)
        })
      }
    }

    return () =>
      globalThis.window.removeEventListener('click', () => {
        checkPushAsk(updateIsOpen, updatePermission)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (webview) {
    return <>{children}</>
  }

  return <PushContext.Provider value={props}>{children}</PushContext.Provider>
}
